module.exports = __webpack_public_path__ + "img/Laptop_Riser.578fd242.png";